import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export default function Pricelists() {
  const navigate = useNavigate();

  const [pricelist, setPricelist] = useState([]);

  const { fetchGraphql, DialogSave } = useSave(null);

  const addonOptions = {
    edit: false,
    open: (tableMeta) => {
      navigate(`/products/pricelists/pricelist/${tableMeta.rowData[0]}`);
    },
    delete: (tableMeta) => {
      // console.log(tableMeta);
      fetchGraphql({
        query: `mutation DeleteProduct($productId: ID) {
          deleteProduct(productId: $productId)
        }`,
        variables: { productId: tableMeta.rowData[0] },
      });
    },
  };

  useEffect(() => {
    fetchGraphql({
      query: `
      query Pricelists {
          pricelists {
            pricelistId
            percentChange
            pricelistName
          }
        }`,
    }).then((result) => setPricelist(result.data.pricelists));
  }, []);
  
  const [textField, selectField, newRecord, actions, options] =
    useDatatableAddon(pricelist, setPricelist, "pricelistId", addonOptions);

  const columns = [
    {
      name: "pricelistId",
      options: {
        display: "excluded",
      },
    },
    {
      name: "pricelistName",
      label: "Pricelist Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            firstRow: true,
            width: "100px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "percentChange",
      label: "Percent Change",
      options: {
        // display: false,

        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "250px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    { ...actions },
  ];

  return (
    <Paper
      sx={{
        width: "100%",
        height: "auto",
        marginLeft: "20px",
        padding: "20px",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    ><DialogSave/>
      <Button
        variant="contained"
        sx={{ margin: "0px 0px 20px auto" }}
        onClick={() => navigate("/products/pricelists/pricelist/new-pricelist")}
      >
        <AddIcon />
        New Pricelist
      </Button>

      <ThemeProvider
        theme={createTheme({
          components: {
            MuiTableBody: {
              styleOverrides: {
                root: {
                  height: "auto",
                },
              },
            },
            MUIDataTableBodyCell: {
              styleOverrides: {
                root: {
                  maxHeight: "50px",
                },
              },
            },
          },
        })}
      >
        <MUIDataTable
          sx={{ height: "100px" }}
          title={"Pricelists"}
          data={pricelist}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </Paper>
  );
}
